module.exports = __webpack_public_path__ + "media/images/bg/quote-f1cb34ff9a65a5a9b2a07ba3f6d3ceaf.svg";